export const DATE_TIME_FORMAT_STYLE = 'YYYY-MM-DD HH:mm:ss';

// export const COMMON_UPLOAD_URL = '/commons/upload';

export const DOWNLOAD_URL = {
  IOS: process.env.VUE_APP_DOWNLOAD_URL_IOS,
  ANDROID: process.env.VUE_APP_DOWNLOAD_URL_ANDROID
};

// export const NE_CAPTCHA_ID = '2de7d80c165f4d04be5667d7be008f75';
export const NE_CAPTCHA_ID = process.env.VUE_APP_NE_CAPTCHA_ID;
export const NE_CAPTCHA_ID_SMART = process.env.VUE_APP_NE_CAPTCHA_ID_SMART;

export const RES_PUBLIC_KEY = process.env.VUE_APP_RES_PUBLIC_KEY;

export const TIM_ENV = process.env.VUE_APP_TIM_ENV;
